import { render, staticRenderFns } from "./AffirmNews.vue?vue&type=template&id=76acb176&"
import script from "./AffirmNews.vue?vue&type=script&lang=js&"
export * from "./AffirmNews.vue?vue&type=script&lang=js&"
import style0 from "./AffirmNews.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports